import { useQuery } from 'react-query';

import { fetchCollectionPoints } from 'api/location';
import { washHub } from 'store/slices';

export const useCollectionPoints = () => {
  const washHubId = washHub.selectors.useSelectedWashHubId();

  const queryKey = `fetch-collection-points-${washHubId}-select`;
  const queryFn = () => fetchCollectionPoints(washHubId);

  const query = useQuery(queryKey, queryFn);

  return query;
};
